module.exports = "/assets/triangle-609aeb4130c1cab3eff7f565c63e1af8.png";